// extracted by mini-css-extract-plugin
export default {"name":"Name_name__mxgW5","border":"Name_border__lktbK"};